/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_DescriptionInputs */

const he_hero_description = /** @type {(inputs: Hero_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התחברו כדי לעקוב אחרי מחירים, לקבל התראות על ירידות מחיר וחזרה למלאי, ולשתף ביקורות על מוצרים.`)
};

const en_hero_description = /** @type {(inputs: Hero_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to track prices, get notified on drops and restocks, and share your product reviews.`)
};

/**
* | output |
* | --- |
* | "Sign in to track prices, get notified on drops and restocks, and share your product reviews." |
*
* @param {Hero_DescriptionInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const hero_description = /** @type {((inputs?: Hero_DescriptionInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_DescriptionInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_hero_description(inputs)
	return en_hero_description(inputs)
});